import GlucoseSlider from "./glucose-slider/GlucoseSlider";
import TriedTreatment from "./heelpain/TriedTreatment";
import PainSlider from "./pain-slider/PainSlider";
import VisaA8 from "./visa/VisaA8";
import VisaG8 from "./visa/VisaG8";
import VisaH8 from "./visa/VisaH8";
import VisaP8 from "./visa/VisaP8";
export const customInputs = {
	PainSlider,
	GlucoseSlider,
	VisaA8,
	VisaP8,
	VisaH8,
	VisaG8,
	TriedTreatment,
};
